module.exports = __webpack_public_path__ + "img/market2_green.30d24936.svg";